export default "__VITE_ASSET__k5f4TEK$__"